import { useCallback, useState } from 'react';

import { readChatThreadPointers, writeChatThreadPointer } from '@/shared/lib';

// The workspace belongs to a user and organization. Page subjects never select
// a conversation. The host remounts only when this workspace identity changes.
export const useAgentChatThread = ({
  workspaceKey,
}: {
  workspaceKey: string;
}) => {
  const [restoreTarget, setRestoreTarget] = useState(
    () => readChatThreadPointers()[workspaceKey] ?? '',
  );
  const [threadID, setThreadID] = useState('');

  const selectThread = useCallback(
    (nextThreadID: string) => {
      writeChatThreadPointer(workspaceKey, nextThreadID);
      setThreadID(nextThreadID);
      setRestoreTarget(nextThreadID);
    },
    [workspaceKey],
  );

  return { threadID, restoreTarget, selectThread };
};
